@if (hasLines) {
<div class="account-entry-lines-panel" [class.open]="isOpen">
    <!-- Bouton onglet -->
    <div class="flex justify-content-start">
        <p-button class="panel-tab-button" [outlined]="true" [rounded]="true" severity="primary"
            (click)="onClickToggle()">
            <div class=" flex align-items-center gap-4">
                <span>Écritures comptables</span>
                <i class="pi" [ngClass]="isOpen ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
            </div>
        </p-button>
    </div>

    <!-- Contenu du panel -->
    @if (isOpen) {
    <div class="surface-0 overflow-y-auto main-shadow" @expandCollapse>
        <app-account-entries-table [lines]="lines" [showTitle]="false" [size]="undefined"></app-account-entries-table>
    </div>
    }
</div>
}